import { motion } from "framer-motion";
import { RotateCcw, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../lib/i18n";

export default function PaymentCancel() {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen flex items-center justify-center px-6 noise-overlay bg-[#040814]">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }} className="relative z-10 max-w-md w-full text-center rounded-3xl border border-white/[0.08] bg-[#0A101F] p-10" data-testid="payment-cancel-card">
        <RotateCcw size={48} className="mx-auto text-slate-400" />
        <h1 className="font-head text-3xl tracking-tight mt-6">{t("payment.cancelTitle")}</h1>
        <p className="text-slate-400 mt-3">{t("payment.cancelSub")}</p>
        <div className="flex flex-col sm:flex-row gap-3 mt-8 justify-center">
          <Link to="/#pricing" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-blue-500 text-white font-semibold hover:bg-blue-600 transition-colors duration-300" data-testid="retry-pricing-btn">
            {t("payment.viewPlans")}
          </Link>
          <Link to="/" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-white/10 text-white hover:bg-white/[0.05] transition-colors duration-300" data-testid="back-home-btn">
            <ArrowLeft size={16} /> {t("payment.home")}
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
